import Globals from "./global";

export function logOutRedirectCall() {
  localStorage.clear();
  const baseUrl = Globals.BASE_URL || "/";
  window.location.replace(baseUrl);
}